/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Section_CompanyInputs */

const en_clients_section_company = /** @type {(inputs: Clients_Section_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const pt_br2_clients_section_company = /** @type {(inputs: Clients_Section_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Clients_Section_CompanyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_section_company = /** @type {((inputs?: Clients_Section_CompanyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Section_CompanyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_section_company(inputs)
	return pt_br2_clients_section_company(inputs)
});